<div style="display: flex">
    <p-dialog
        header="Add Invoice Selection"
        [(visible)]="addSelection"
        [maximizable]="false"
        [modal]="true"
        [closable]="false"
        [closeOnEscape]="false"
        [style]="{ 'max-width': '50%', 'max-height': '50%' }"
    >
        <form
            [formGroup]="addSelectionFormGroup"
            #addSelectionForm="ngForm"
            id="eventForm"
            class="grid"
        >
            <!-- <label style="font-size: 11px">Start Date</label>
            <div style="margin-bottom: 1em">
                <p-calendar appendTo="body" formControlName="startDate">
                </p-calendar>
            </div> -->
            <p-floatLabel variant="on" class="mb-3 mt-4 w-full">
                <p-select
                    [style]="{ 'width': '100%' }"
                    [options]="invoiceProperties"
                    [filter]="true"
                    appendTo="body"
                    [autoDisplayFirst]="false"
                    formControlName="Invoicepropertyid"
                >
                </p-select>
                <label for="float-dd">Item</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3 w-full">
                <input
                    formControlName="Propertylabel"
                    class="ef-dialog-control w-full"
                    type="text"
                    pInputText
                    id="modnbr"
                    required
                />
                <label for="float-dd">Name</label>
            </p-floatLabel>
            <p-floatLabel variant="on" class="mb-3 w-full">
                <textarea
                    formControlName="Propertytext"
                    [rows]="4"
                    class="ef-dialog-control w-full"
                    pInputTextarea
                    required
                ></textarea>
                <label for="float-dd">Text</label>
            </p-floatLabel>
        </form>
        <ng-template #footer>
            <button
                type="button"
                pButton
                class="p-button-text p-button-success"
                icon="pi pi-check"
                (click)="Save.next(this.addSelectionFormGroup.value)"
                label="Confirm"
            ></button>
            <button
                type="button"
                pButton
                class="p-button-text p-button-danger"
                (click)="this.Cancel.next()"
                icon="pi pi-times"
                label="Cancel"
            ></button>
        </ng-template>
    </p-dialog>
</div>
